import { Injectable } from '@angular/core';
import {
  AuthRedirectStorageService,
  AuthStatePersistenceService,
  AuthStorageService,
  StatePersistenceService,
  SyncedAuthState,
  UserIdService,
} from '@spartacus/core';
import { Observable, combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomAuthStatePersistenceService extends AuthStatePersistenceService {
  constructor(
    statePersistenceService: StatePersistenceService,
    userIdService: UserIdService,
    authStorageService: AuthStorageService,
    authRedirectStorageService: AuthRedirectStorageService,
  ) {
    super(statePersistenceService, userIdService, authStorageService, authRedirectStorageService);
  }

  /**
   * Спартакусяне запретили прокидывать данные через TransferState для авторизованного
   * пользователя. Нам в свою очередь нужно что бы данные прокидывались, поэтому тут мы
   * возвращаем всегда false. На момент реализации данной задачи (версия @spartacus/core": "~3.0.0"),
   * данный метод используется только в функции TransferStateReducer.
   */
  public isUserLoggedIn(): boolean {
    return false;
  }

  protected getAuthState(): Observable<SyncedAuthState> {
    return combineLatest({
      authToken: this.authStorageService.getToken().pipe(
        filter((state) => !!state),
        map((state) => {
          return {
            ...state,
          };
        }),
      ),
      userId: this.userIdService.getUserId(),
      redirectUrl: this.authRedirectStorageService.getRedirectUrl(),
    }).pipe(
      map(({ authToken, userId, redirectUrl }) => {
        let token = authToken;
        if (token) {
          token = { ...token };
        }

        return { token, userId, redirectUrl };
      }),
    );
  }
}
